import { render, staticRenderFns } from "./ChannelsListView.vue?vue&type=template&id=34ed091f&"
import script from "./ChannelsListView.vue?vue&type=script&lang=js&"
export * from "./ChannelsListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports